/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default { 

  resetExtraTypes() {
    // reset store to empty
    Store.dispatch('loads/setExtraTypes', {
      extraTypes: [],
    });
  }, 

  async listExtraTypes(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['loads/extraTypes'].length < 1) {
      try {
        const response = await Api(true).get('/load_extra/list_types');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetExtraTypes();
            return response.data.message;
          } else {
            Store.dispatch('loads/setExtraTypes', {
              extraTypes: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetExtraTypes();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('loadExtra.ts - listExtraTypes - 140 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  createExtraFromMovement(params: {
    id: number,
    extraTypeId: number,
    amount: number,
    comment?: string,
  }) {
    return Api(true).post('/load_extra/create_movement', params);
  },

  createExtraFromApproval(params: {
    id: number,
    extraTypeId: number,
    amount: number,
    comment?: string,
  }) {
    return Api(true).post('/load_extra/create_approval', params);
  },

  listExtraSummary(config: {params: { loadId: number }}) {
    return Api(true).get('/load_extra/summary', config);
  },

  listByLoad(config: {params: { loadId: number }}) {
    return Api(true).get('/load_extra/list_by_load', config);
  },

  delete(params: { id: number, loadId: number, comment?: string }) {
    return Api(true).post('/load_extra/delete', params);
  },

};